import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { SearchResultsSettingsContext } from '../../../SearchResultsSettingsContext';
import { CurrencyCodeContextProvider } from '../CurrencyCodeContext';
import OrderItemsWrapper from '../OrderItemsWrapper/OrderItemsWrapper';
import Price from '../../../../../../../../common/Price/Price';
import FormattedDate from '../../../../../../../../common/FormattedDate/FormattedDate';
import { getOrderingSystem } from '../../../../../../../../../selectors/tools';
import { getMappedValueFromOrderOrItem, truncateWithEllipsis } from '../../../../../../../../../util';
import { Checkbox, CheckBoxColumn, ResultRowOrders, ResultsColumn } from '../DTOrderSearchResult.styles';

const DTOrderSearchCustomResult = (props) => {
  const { order, markAsOrder, isSelected, isLast, onCheckboxClick } = props;
  const { settings } = useContext(SearchResultsSettingsContext);
  const orderingSystem = useSelector(getOrderingSystem);
  const currencyCode = getMappedValueFromOrderOrItem(order, 'currency', orderingSystem);

  const handleCheckboxClick = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      onCheckboxClick(true, order);
    } else {
      onCheckboxClick(false, order);
    }
  };

  const columnWidth = 100 / Object.values(settings).length + '%';

  const renderData = (value) => {
    const mappedValue = getMappedValueFromOrderOrItem(order, value, orderingSystem);

    switch (value) {
      case 'totalPrice':
        return (
          <Price
            value={mappedValue}
            isValueSetInCents={String(orderingSystem) === 'custom_rbi'}
            currencyCode={currencyCode}
          />
        );
      case 'fullName':
        return (value && truncateWithEllipsis(mappedValue, 25)) || '-';
      case 'createdAt':
        return <FormattedDate date={mappedValue} orderingSystem={orderingSystem} />;
      default:
        return <span>{mappedValue}</span>;
    }
  };

  return (
    <div>
      <ResultRowOrders checked={isSelected} markAsOrder={markAsOrder}>
        <CheckBoxColumn>
          <Checkbox type="checkbox" checked={isSelected} onChange={handleCheckboxClick} />
        </CheckBoxColumn>
        {Object.values(settings).map((value) => (
          <ResultsColumn key={value} width={columnWidth}>
            {renderData(value)}
          </ResultsColumn>
        ))}
      </ResultRowOrders>
      {isSelected && (
        <CurrencyCodeContextProvider value={currencyCode}>
          <OrderItemsWrapper showLoadingUnderline={isLast} order={order} />
        </CurrencyCodeContextProvider>
      )}
    </div>
  );
};

export default DTOrderSearchCustomResult;
